import React, { FC } from 'react';
import { Dropdown } from '@silverfort/sf-components';
import { UserFilters } from '../../../types/UserFilters';
import { LastAccessOptions } from '../../../common/lastAccess';
import { StaleStatusOptions } from '../../../common/staleStatus';

type UsersQueryBuilderProps = {
    updateFilter: <K extends keyof UserFilters>(field: K, value: UserFilters[K]) => void;
};

export const UsersQueryBuilder: FC<UsersQueryBuilderProps> = ({ updateFilter }) => {
    const updateLastAccess = (value?: number | Array<number>) => {
        const val = Array.isArray(value) ? value.at(0) : value;

        updateFilter('lastAccessInDays', val);
    };

    const updateStatus = (value?: boolean | Array<boolean>) => {
        const val = Array.isArray(value) ? value.at(0) : value;

        updateFilter('is_stale', val);
    };

    return (
        <section className="flex gap-2">
            <Dropdown
                items={StaleStatusOptions}
                key="status"
                onChange={updateStatus}
                onRemove={updateStatus}
                removable
                title="Status"
                variant="filter"
            />

            <Dropdown
                key="lastAccessInDays"
                items={LastAccessOptions}
                onChange={updateLastAccess}
                onRemove={updateLastAccess}
                removable
                title="Last login before"
                variant="filter"
            />
        </section>
    );
};
